export default {"src":"/_next/static/media/eye.e9cc02a7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};